<div class="claroBigLabel_container" [ngStyle]="{'height':height, 'width':width}">
    <!-- <span class="claroBigLabel_iconBg" [ngStyle]="{'background-color':  colorScheme}">
        <span class="contentContainerHidden">
            <mat-icon class="claroNotificationIcon">{{iconPath}}</mat-icon>
            <span class="claroBigLabel_text" [ngStyle]="{'font-size':fontSize}">{{labelText}}</span>
        </span>    
    </span>  -->
    <span class="claroBigLabel_contentContainer" [ngClass]="{'is-mobile-view': isMobileView}" [ngStyle]="{'background-color':  colorScheme}">
        <span><mat-icon class="claroNotificationIcon" [ngClass]="{'is-mobile-view': isMobileView}" [ngStyle]="{'font-size':iconFontSize}">{{iconPath}}</mat-icon></span>
        <span class="claroBigLabel_text" [ngStyle]="{'font-size':fontSize}">{{labelText}}</span>
    </span>
</div>
